import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { OnyxIconComponent, OnyxMessageComponent } from '@onyx/angular';
import type { SwapPoint } from '../../../../../fleet/common/interfaces/technical-point';
import { SwapModalDriverReportItemComponent } from './swap-modal-driver-report-item/swap-modal-driver-report-item.component';

@Component({
  selector: 'app-swap-modal-driver-report',
  imports: [
    SwapModalDriverReportItemComponent,
    OnyxMessageComponent,
    OnyxIconComponent,
    TranslatePipe,
  ],
  templateUrl: './swap-modal-driver-report.component.html',
  styleUrl: './swap-modal-driver-report.component.scss',
})
export class SwapModalDriverReportComponent {
  public readonly technicalPoints = input.required<SwapPoint[]>();
  public readonly isDouble = input.required<boolean>();
  public readonly isRecorded = input.required<boolean>();

  protected readonly I18N = 'map.swapPanel.swapModal';
}
